import { Routes, mapToCanActivate, mapToResolve } from "@angular/router";

import { FlowComponent } from "./components/flow/flow.component";
import { OnBehalfFlowComponent } from "./components/on-behalf-flow/on-behalf-flow.component";
import { WorkflowResolver } from "./resolvers/workflow.resolver";
import { InstantiateFlowGuardService } from "../auth/guards/instantiate-flow-guard.service";
import { BaseGuardService } from "../auth/guards/base-guard.service";
import { ReadOnlyFlowComponent } from "./components/flow/read-only-flow/read-only-flow.component";
import { ReadOnlyOnBehalfComponent } from "./components/on-behalf-flow/read-only-on-behalf/read-only-on-behalf.component";

const baseGuard = [BaseGuardService];
const flowGuards = [InstantiateFlowGuardService];

export const FLOW_ROUTES: Routes = [
    {
        path: "create/:id",
        component: FlowComponent,
        resolve: { workflow: mapToResolve(WorkflowResolver) },
        canActivate: mapToCanActivate(flowGuards)
    },
    {
        path: "on-behalf/:id",
        component: OnBehalfFlowComponent,
		resolve: { workflow: mapToResolve(WorkflowResolver) },
		canActivate: mapToCanActivate(baseGuard)
    },
    {
        path: "review-on-behalf/:id",
        component: ReadOnlyOnBehalfComponent,
		resolve: { workflow: mapToResolve(WorkflowResolver) },
		canActivate: mapToCanActivate(baseGuard)
    },
    {
        path: ":id",
        component: FlowComponent,
		resolve: { workflow: mapToResolve(WorkflowResolver) }
    },
    {
        path: "on-behalf/:id/:section/:page",
        component: OnBehalfFlowComponent,
		resolve: { workflow: mapToResolve(WorkflowResolver) },
		canActivate: mapToCanActivate(baseGuard)
    },
    {
        path: ":id/:section/:page",
        component: FlowComponent,
		resolve: { workflow: mapToResolve(WorkflowResolver) }
    },
    {
        path: "review/:id",
        component: ReadOnlyFlowComponent,
		resolve: { workflow: mapToResolve(WorkflowResolver) }
    },
    {
        path: ":id/:workItemId",
        component: FlowComponent,
		resolve: { workflow: mapToResolve(WorkflowResolver) },
        canActivate: mapToCanActivate(baseGuard)
    }
]